export default __webpack_public_path__ + "static/media/Bracers of the Renegade.d9003f43.jpg";